import { Encodable } from "../Encodable";
import { ConcreteEncodable } from "./ConcreteEncodable";

import { RelationshipEncoder } from "../../encoder/RelationshipEncoder";

import * as CubiqTS from "../../index";

export class Relationship extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.model.Relationship";

  public orderId: string;
  public orderRef: string;
  public relationshipType: CubiqTS.OrderRelationshipType;
  public messageId: string;
  public order: CubiqTS.OrderDataImpl;
  constructor() {
    super();
    this.encoder = RelationshipEncoder.Instance;
    this.setEncodableType(Relationship.enType);
  }

  public toString(): string {
    return (
      "Relationship[" +
      "orderId=" +
      this.orderId +
      "relationshipType=" +
      this.relationshipType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
